<template>
  <base-modal modal-content-class="reg_after_login">
    <div class="modal-card">
      <div class="content">
        <img src="/static/images/register/mobile_img.svg" alt="info">
        <p>{{ getTranslations.home_modals_simplify_registration_text }}</p>
      </div>
    </div>
  </base-modal>
</template>

<script>
import {mapGetters} from 'vuex'
import BaseModal from '../../common/modal/BaseModal.vue'

export default {
  name: 'RegisterViaSms',
  components: {BaseModal},
  computed: {
    ...mapGetters('i18n', ['getTranslations'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/home/modals/RegisterViaSms.vue